import {ICodebookEntry} from '../../../../../incase-domain/codebook';
import {
    IElementQuestionAnswer,
    IElementQuestionnaire,
    IQuestionAnswerType,
} from '../../../../../incase-domain/elements/base/questionElementBase';

export const getCodebookDefaultAnswerType = (element: IElementQuestionnaire): IQuestionAnswerType => {
    if ('defaultCodebookAnswerType' in element) {
        return element.defaultCodebookAnswerType as IQuestionAnswerType;
    }

    return 'incorrect';
};

export const mapCodebookEntriesToAnswers = (element: IElementQuestionnaire, entries: ICodebookEntry[]): IElementQuestionAnswer[] => {
    return entries?.map((entry) => ({
        codebookEntryId: entry._id,
        text: entry.value,
        type: element.answers.find((answer) => answer.codebookEntryId === entry._id)?.type || getCodebookDefaultAnswerType(element),
        comment: element.answers.find((answer) => answer.codebookEntryId === entry._id)?.comment || '',
        parentKey: entry.parentKey,
        depth: entry.depth || 0,
        numberOfChildren: entry.numberOfChildren || 0,
    }));
};
